import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ApplicationTaskModel } from 'projects/borrower-app/src/app/models/borrower-portal/application-task-model';
import { resolveDistinctTaskDescription, resolveTaskText, TaskTextField } from './task-text';

/**
 * LLS-886: task title/description/note in the portal language. Impure so it re-evaluates on language change.
 * 'distinctDescription' returns the description only when it differs from the displayed title.
 */
@Pipe({ name: 'taskText', pure: false, standalone: true })
export class TaskTextPipe implements PipeTransform {
  constructor(private readonly _translocoService: TranslocoService) {}

  transform(task: ApplicationTaskModel | null | undefined, field: TaskTextField | 'distinctDescription'): string | undefined {
    const lang = this._translocoService.getActiveLang();
    const translate = (key: string) => this._translocoService.translate(key);
    return field === 'distinctDescription'
      ? resolveDistinctTaskDescription(task, lang, translate)
      : resolveTaskText(task, field, lang, translate);
  }
}
